export const GET_ALL_PRODUCTS = "get/all/products";
export const ADD_PRODUCTS = "add/products";
export const UPDATE_PRODUCTS = "update/products";
export const DELETE_PRODUCTS = "delete/products";
export const LOADING_PRODUCTS = "loading/products";
export const ERROR_PRODUCTS = "error/products";
export const RESET_PRODUCTS = "reset/products";
